'use strict';
define(['jquery'], function () {
    function StructureController($scope) {
        function buildCategories() {
            if (!$scope.baseCategories || !$scope.base || !$scope.base.exams) {
                return;
            }
            $scope.categories = $scope.baseCategories;

            $scope.categoriesWithExams = {};
            
            for (var property in $scope.categories) {
                $scope.categoriesWithExams[property] = {
                    categoryId: property,
                    exams: []
                };  
            }
                        
            for (var exam in $scope.base.exams) { 
                for (var property in $scope.categories) {
                    if ($scope.categories.hasOwnProperty(property)) {
                        if ($scope.categories[property].indexOf(exam) != -1) {
                            $scope.categoriesWithExams[property].exams.push($scope.base.exams[exam]);
                        }
                    }
                }
            }
        }

        $scope.$watch('baseCategories', buildCategories);
    }
    StructureController.$inject = ['$scope'];
    return StructureController;
});
